import GaEvent from './GaEvent';

export default class InboxOpenedGaEvent extends GaEvent {
  constructor() {
    super('inbox_opened');
  }
}
